import { reactive } from 'vue'
import api from '../../api/v2/api'
import UserQuestionForm, { UserQuestionListForm } from '../../api/v2/forms/user_question'

class UserQuestionState {
  isLoading = false
  async fetchList (userQuestionListForm: UserQuestionListForm) {
    return await api.userQuestion.index(userQuestionListForm)
  }
  async create(userQuestionForm: UserQuestionForm){
    this.isLoading = true
    try {
      return await api.userQuestion.create(userQuestionForm)
    } finally {
      this.isLoading = false
    }
  }

  async fetchMyList(page = 1, search = ""){
    return await api.userQuestion.my({ page: page, search: search });
  }
}

// Wrap in reactive() for Vue 3 reactivity
export const userQuestionState = reactive(new UserQuestionState()) as UserQuestionState
